import { DomainError, SyncError, TransportError, } from "@econ-v1/domain";
import { CapabilityAuthorization } from "./authorization.js";
export class CapabilityDispatcher {
    #authorization;
    #homeNode;
    #providers = new Map();
    constructor(homeNode, authorization) {
        this.#homeNode = homeNode;
        this.#authorization = authorization;
    }
    async invoke(context, capability, payload) {
        this.#authorization.assertCapabilityDeclared(context, capability);
        const provider = this.#providers.get(capability);
        if (provider !== undefined)
            return provider(payload, context);
        try {
            return await this.#homeNode.invoke({
                operation: "POST /api/v2/system/capabilities/invoke",
                payload: { appName: context.appName, capability, payload },
            });
        }
        catch (error) {
            if (error instanceof DomainError || error instanceof SyncError || error instanceof TransportError)
                throw error;
            throw new TransportError({ code: "unavailable", message: "Capability transport failed" });
        }
    }
    register(capability, provider) {
        if (this.#providers.has(capability))
            throw new Error(`Capability ${capability} is already registered`);
        this.#providers.set(capability, provider);
        return () => {
            if (this.#providers.get(capability) === provider)
                this.#providers.delete(capability);
        };
    }
}
//# sourceMappingURL=dispatcher.js.map